module.exports = __webpack_public_path__ + "static/media/b18.e0577734.svg";